import React, { useEffect } from "react";
import { Snackbar } from "@material-ui/core";

interface Props {
  message: string;
  handleClose: () => void;
  timeoutInSeconds?: number;
}

export default function TemporaryNotification({
  message,
  handleClose,
  timeoutInSeconds,
}: Props) {
  // If the timeoutInSeconds is provided the snackbar will close automatically after the timeout.
  useEffect(() => {
    if (!timeoutInSeconds) return;
    const timer = setTimeout(() => handleClose(), timeoutInSeconds * 1000);
    return () => clearTimeout(timer);
  }, [handleClose, timeoutInSeconds]);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={true}
      onClose={handleClose}
      message={message}
    />
  );
}
